import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import {
    createEmptyPacksDrawerForm,
    PacksDrawerDetails,
} from '../PacksDrawerDetails/PacksDrawerDetails';

import { useCreatePacksDrawer } from '../../hooks/packsDrawer';

import { RouteTo } from '../../routes';

export const PacksDrawerCreatePage = () => {
    const {
        recordId,
        isLoading: isCreateLoading,
        createRecord,
    } = useCreatePacksDrawer();
    const navigate = useNavigate();

    useEffect(() => {
        if (recordId) {
            navigate(RouteTo.PacksDrawerEdit(recordId.toString()));
        }
    }, [recordId]);

    async function onSave(form: ReturnType<typeof createEmptyPacksDrawerForm>) {
        try {
            await createRecord({
                packId: form.packId,
                thumbnailMediaId: form.thumbnailMediaId,
                active: form.active,
                isFree: form.isFree,
            });
            return true;
        } catch {
            return false;
        }
    }

    return (
        <PacksDrawerDetails
            isNew={true}
            onSave={onSave}
            initialForm={createEmptyPacksDrawerForm()}
            isSaving={isCreateLoading}
        />
    );
};
